/**
 * Set a cookie value
 * @param {string} name - identifies the cookie
 * @param {string} value - the value
 * @param {int} expirationDays - expiration in days
 * @param {string} theDomain - The domain can be used to specify a subdomain for your cookie.
 * @returns {void}
 */
function setCookie(name, value, expirationDays = 365, theDomain = false) {
  let theSecure;
  if (location.protocol === 'http:') {
    theSecure = false;
  }
  if (location.protocol === 'https:') {
    theSecure = true;
  }
  value = encodeURI(value);
  const d = new Date(Date.now() + expirationDays * 24 * 60 * 60 * 1000);
  const expires = `; expires=${d.toUTCString()}`;
  const path = '; path=/';
  const domain = theDomain ? `; domain=${theDomain}` : '';
  const secure = theSecure ? '; secure' : '';
  const sameSite = '; SameSite=Lax';
  // console.log(`${name}=${value}${expires}${path}${domain}${secure}${sameSite}`);
  document.cookie = `${name}=${value}${expires}${path}${domain}${secure}${sameSite}`;
}

/**
 * Set a cookie without expiration date
 * @param {string} name - identifies the cookie
 * @param {string} value - the value
 * @param {string} theDomain - The domain can be used to specify a subdomain for your cookie.
 */

function setCookieWithoutExpiration(name, value, theDomain = false) {
  let theSecure;
  if (location.protocol === 'http:') {
    theSecure = false;
  }
  if (location.protocol === 'https:') {
    theSecure = true;
  }
  value = encodeURI(value);
  // const expires = "; ";
  const path = '; path=/';
  const domain = theDomain ? `; domain=${theDomain}` : '';
  const secure = theSecure ? '; secure' : '';
  const theCookie = `${name}=${value}${path}${domain}${secure}`;

  document.cookie = theCookie;
}

/**
 * Get a cookie value by name.
 * @param {string} cookieName - an identifier
 * @return {boolean|string} the value or false if nothing was set.
 */
function getCookie(cookieName) {
  const name = cookieName + '=';
  const ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];

    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) !== -1) {
      return c.substring(name.length, c.length);
    }
  }
  return false;
}

/**
 *
 * @param {string} name - the name of the cookie
 * @param {string} path - the path of the cookie
 */
function deleteCookie(name, path) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT;' + (path ? ' path=' + path : '');
}

/**
 *
 * @type {{deleteCookie: deleteCookie, setCookie: setCookie, getCookie: getCookie, setCookieWithoutExpiration: setCookieWithoutExpiration}}
 */
export const cookieService = {
  setCookie,
  setCookieWithoutExpiration,
  getCookie,
  deleteCookie,
};
